import { CheckboxFilter, FiltersBar, TextFilter, SimpleFiltersObjectValues, MultiSelectFilter } from "@britishcouncil/react-admin";

export enum ExaminerAvailabilityFilterType {
  Available = 1,
  Partially = 2,
  Unavailable = 3,
  NotProvided = 4
}

export type ExaminerSearchFilters = {
  examiner: TextFilter;
  availability: MultiSelectFilter<ExaminerAvailabilityFilterType>;
  showExaminersFromOtherLocationsWithinThisCentre: CheckboxFilter;
};

const availabilityOptions = [
  { text: 'Available', value: ExaminerAvailabilityFilterType.Available },
  { text: 'Partially', value: ExaminerAvailabilityFilterType.Partially },
  { text: 'Unavailable', value: ExaminerAvailabilityFilterType.Unavailable },
  { text: 'Not provided', value: ExaminerAvailabilityFilterType.NotProvided }
];

const examinerSearchFiltersOptions: ExaminerSearchFilters = {
  examiner: {
    type: 'text',
    isMain: true,
    placeholder: 'Find examiner',
  },
  availability: {
    type: 'multiselect',
    label: 'Availability',
    options: availabilityOptions,
    dropdownOptions: {
      placeholder: 'Any',
      clearable: true,
      search: true,
      style: { maxWidth: '150px', minWidth: '150px' }
    },
  },
  showExaminersFromOtherLocationsWithinThisCentre: {
    type: 'checkbox',
    label: 'Show Examiners from other Locations within this Centre'
  },
}

export const ManageExaminerToRoomStructureFilterBar = ({ onFiltersChange }: { onFiltersChange: (values: SimpleFiltersObjectValues<ExaminerSearchFilters>) => void }) => {
  return <FiltersBar clearable onFiltersChange={onFiltersChange} filters={examinerSearchFiltersOptions} initialValues={ExaminerSearchFiltersInitialState} />;
};

export const ExaminerSearchFiltersInitialState: SimpleFiltersObjectValues<ExaminerSearchFilters> = {
  examiner: undefined,
  availability: undefined,
  showExaminersFromOtherLocationsWithinThisCentre: true,
};